export enum InspectionType {
  validationInspection = 'validationInspection',
  vehicleCondition = 'vehicleCondition',
  nonValidationInspection = 'nonValidationInspection',
  autofillTemplate = 'autofillTemplate',
  complaint = 'complaint',
  checkin = 'checkin',
  handover = 'handover',
}
